export const url = {
  /*
  *管理&&上传
  *
  * */
  // 公共
  lifestyleSegmentList: '/auth/trendCategory/findByPid', // segment & Lifestyle可选值
  userList: '/auth/user/searchUserList', // 获取用户列表
  approverList: '/auth/user/searchApproveUserList', // 获取审核列表
  unreadManage: '/manage/trend/getStatusCount', // 审核者未读
  unreadUpload: '/auth/trend/getStatusCount', // 审核者未读
  getUploadTrendCount: '/auth/trend/myTrendCount',
  // 列表
  allList: '/auth/trend/findList', //dlite3列表
  myList: '/auth/trend/myFindList', // 上传列表
  checkList: '/manage/trend/findList', //审核者的列表
  // 预览
  preview: '/auth/trend/preView',
  checkPreview: '/manage/trend/preView',
  // 详情
  detail: '/auth/trend/detail',
  checkDetail: '/manage/trend/detail',
  // 操作
  enableTrending: '/manage/trend/updateStatus',
  changeStatus: '/manage/trend/enableOperate',
  setTrending: '/manage/trend/updateTrending',
  addTrend: '/auth/trend/save', // 新增
  editTrend: '/auth/trend/update', // 编辑
  updateTrend: '/manage/trend/update',
  submitWithdraw: '/auth/trend/updateStatus', // 提交撤回
  judge: '/manage/trend/approve', // 审核
  // exports: 'auth/trendHistory/exportHistoryList', // 导出,
  upload: '/auth/public/upload_file', // 上传图片和文件
  uploadWatermark: '/auth/public/uploadFile/water', // 上传图片和文件
  key: '/auth/keywords/searchKeyword', // 获取关键词，
  /*
  * 分类
  *
  * */
  lifeSegment: '/manage/trendCategory/findList', // 获取lifeSegment列表
  enableLifeSegment: '/manage/trendCategory/updateStatus', // 启用/停用lifeSegment
  lifeSegmentDetail: '/manage/trendCategory/detail', // lifeSegment详情
  addLifeSegment: '/manage/trendCategory/save', // 新增lifeSegment
  editLifeSegment: '/manage/trendCategory/update', // 编辑lifeSegment
  ableRank: '/manage/trendCategory/checkRank',
  saveKeyword: '/manage/trendKeyword/save',
  updateKeyword: '/manage/trendKeyword/update',
  enableKeyword: '/manage/trendKeyword/updateStatus',
  keywordList: '/manage/trendKeyword/findList',
  /*
  *d'lite3 pc部分
  *
  * */
  dliteTabList: '/auth/trendCategory/findList', // lifestyle, segment, cids
  dliteList: '/auth/trend/findList', // lifestyle, segment, cids的筛选结果列表
  deliteKeyword: '/auth/trendKeywords/findKeywordByTrendQuery',
  dliteDetail: '/auth/trend/findById',
  getLastApprovalDate: '/manage/trend/getLastApprovalDate',
  getLastUpdateTime: '/auth/trend/lastUpdateTime',
  getHighLight: '/auth/trend/top1',
  deleteDraft: '/auth/trend/delete',
  setKeyProduct: '/manage/trend/key/set'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/trend.js